import { buildClasses } from "../utils/buildClasses";
import { RyeMainContentContainerBase } from "./RyeMainContentContainerBase";

export function RyeMainContentFooter({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  return (
    <RyeMainContentContainerBase
      roundedTl={false}
      roundedTr={false}
      flexGrow={false}
      flexShrink={false}
      padBottom={false}
      height="auto"
      zIndex="20"
      overflowY="visible"
    >
      <div
        className={buildClasses(
          "w-full",
          "flex",
          "justify-end",
          "items-center",
          "py-2",
        )}
      >
        {children}
      </div>
    </RyeMainContentContainerBase>
  );
}
